import { render, staticRenderFns } from "./AnswerTypeRadioButton.vue?vue&type=template&id=55a3c5a6"
import script from "./AnswerTypeRadioButton.vue?vue&type=script&lang=js"
export * from "./AnswerTypeRadioButton.vue?vue&type=script&lang=js"
import style0 from "./AnswerTypeRadioButton.vue?vue&type=style&index=0&id=55a3c5a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports